import React, { useEffect, useState } from "react";
import {
  Button,
  Switch,
  Typography,
  Row,
  Col,
  Space,
  Flex,
  message,
  Spin,
} from "antd";
import styled from "styled-components";
import { Header } from "antd/es/layout/layout";
import { HostingFeeLogo, IconWeb } from "../../../assets/icons";
import api from "../../../api/api";
import { getFormattedNumber } from "../../../utils";
import Processing from "./Processing";
import PaymentSuccessful from "./PaymentSuccessful";
import { IMG_WALLET_BG } from "../../../assets/images";
import ArrowRight from "./HostingFeeOrderDetails/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";



const { Title, Link } = Typography;

const Container = styled.div`
  padding: 24px;
  background: #f9f9f9;
`;

const ProceedButton = styled(Button)`
  width: 100%;
  height: 48px;
  background-color: #1677ff;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
`;

const TitleText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #1e1e1e;
  text-align: left;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #7a7a7a;
  text-align: left;
`;

const Card = styled.div`
  padding: 24px;
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
`;
const SpinWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const PayHostingFee = () => {
  const [data, setData] = React.useState();
  const [remainingBalance, setRemainingBalance] = React.useState(0);
  const [hostingFee, setHostingFee] = React.useState({});
  const [storeStatus, setStoreStatus] = React.useState("");
  const [domainStatusData, setDomainStatusData] = React.useState({});
  const [autoRenew, setAutoRenew] = React.useState(true);
  const [seoInfo, setSeoInfo] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [orderId,setOrderId] = useState("");

  const {t} = useTranslation();
  
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([
      getPanelInfo(),
      checkDomainStatus(),
      getStoreSeo(),
      checkHostingFee(),
      getRemainingBalance(),
    ]).finally(() => setDataLoaded(true));
    // eslint-disable-next-line
  }, []);

  const getPanelInfo = async () => {
    return api
      .getPanelInfo()
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const checkDomainStatus = async () => {
    return api
      .checkDomainStatus()
      .then(({ data, store }) => {
        setDomainStatusData(data);
        setStoreStatus(store?.status);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const getStoreSeo = async () => {
    return api
      .getStoreSeo()
      .then(({ data }) => {
        setSeoInfo(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const checkHostingFee = async (custom_domain) => {
    return api
      .checkHostingFee({ custom_domain })
      .then(({ data }) => {
        setHostingFee({
          toPay: data.toPay,
          amount: data.hostingFees?.amount,
        });
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const getRemainingBalance = async () => {
    return api
      .getWalletBalance()
      .then(({ data }) => {
        setRemainingBalance(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const onProceed = () => {
   const balance = Number(remainingBalance?.balance?.amount ?? 0);
  const feeAmount = Number(hostingFee?.amount ?? 0);
  
  if (balance >= feeAmount) {
      setLoading(true);
      const payload = {
        auto_renew: autoRenew,
        hosting_fee: +feeAmount,
        sub_total: +feeAmount,
        total: +feeAmount,
      };

      api
        .proceedHostingFee(payload)
        .then((res) => {
        const responseData = res?.data;
        setOrderId(responseData?.id);
          message.success(t('hosting_paid_success'));
          Promise.all([getRemainingBalance(), checkHostingFee()]).finally(() =>
            setLoading(false)
          );
        })
        .catch((error) => {
          message.error(error);
          setLoading(false);
        });
    } else {
      message.error(t('insufficient_balance_to_pay'));
    }
  };

  if (!dataLoaded) {
    return (
      <SpinWrapper>
        <Spin />
      </SpinWrapper>
    );
  }


  return (
    <div
      style={{ height: "100vh", overflowY: "scroll", background: "#f9f9f9" }}
    >
      <Header
        style={{
          padding: "4px 0",
          backgroundColor: "#fff",
          borderBottom: "1px solid #F0F0F0",
          textAlign: "center",
          position:"relative"
        }}
      >
        <HostingFeeLogo style={{ marginTop: 8 }} />
       <div
       onClick={() => navigate("/home/template-management/edit-template")}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            marginLeft:"20px",
            cursor:"pointer"
          }}
        >
          <img
            src={ArrowRight}
            alt="Arrow"
            width={30}
            height={30}
            style={{ transform: "rotate(180deg)",border:"1px solid #cecece", padding:"3px 12px",borderRadius:"5px" }}
          />
        </div>
      </Header>

      {loading ? (
        <Processing />
      ) : hostingFee?.toPay ? (
        <Container>
          <TitleText>{t('pay_hosting_fee')}</TitleText>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={14}>
              <Card style={{ marginBottom: 24 }}>
                <TitleText>{t('summary')}</TitleText>
                <Flex alignItems={"center"} gap={8}>
                  <div
                    style={{
                      backgroundColor: "#eaeaea",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px",
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      border: "1px solid #eaeaea",
                    }}
                  >
                    <IconWeb />
                  </div>
                  <Space direction="vertical">
                    <Text strong>{seoInfo?.seo_title}</Text>
                    <Link href={domainStatusData?.domain_name} target="_blank">
                      {domainStatusData?.domain_name}
                    </Link>
                  </Space>
                </Flex>
              </Card>
              <Card>
                <TitleText>{t('select_to_pay')}</TitleText>
                <Flex style={{ width: "100%", flexDirection: "column" }}>
                  <Text>{t('pay_with_wallet')}</Text>
                  <Card
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                      background: "#0a0c2a",
                      backgroundImage: `url(${IMG_WALLET_BG})`,
                      backgroundSize: "contain",
                      backgroundRepeat: "repeat",
                      backgroundPosition: "start",
                      borderRadius: "12px",
                    }}
                  >
                    <div>
                      <Text style={{ color: "#aaa" }}>{t('remaining_balance')}</Text>
                      <Title level={3} style={{ color: "white", margin: 0 }}>
                        ${" "}
                        {getFormattedNumber(
                          parseFloat(remainingBalance?.balance?.amount)
                        )}
                      </Title>
                    </div>
                  </Card>
                  <ProceedButton type="primary" onClick={onProceed}>
                    {t('processed')} (${" "}
                    {getFormattedNumber(parseFloat(hostingFee?.amount))})
                  </ProceedButton>
                </Flex>
              </Card>
            </Col>
            <Col xs={24} md={10}>
              <Card>
                <TitleText>Total</TitleText>
                <Space direction="vertical" style={{ width: "100%" }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text>{t('auto_renew')} {autoRenew ? "ON" : "OFF"}</Text>
                    <Switch checked={autoRenew} onChange={setAutoRenew} />
                  </div>
                  <div
                    style={{ margin: "8px 0", border: "0.1px solid #f0f0f0" }}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text>{t('hosting_fee_paid')}</Text>
                    <Text>$ {getFormattedNumber(hostingFee?.amount || 0)}</Text>
                  </div>
                  <div
                    style={{ margin: "8px 0", border: "0.1px solid #f0f0f0" }}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text>{t('sub_total')}</Text>
                    <Text>$ {getFormattedNumber(hostingFee?.amount || 0)}</Text>
                  </div>
                  <div
                    style={{ margin: "8px 0", border: "0.1px solid #f0f0f0" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: 600,
                    }}
                  >
                    <Text>{t('total')}</Text>
                    <Text strong style={{ fontSize: 18 }}>
                      $ {getFormattedNumber(parseFloat(hostingFee?.amount))}
                    </Text>
                  </div>
                </Space>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <PaymentSuccessful store={domainStatusData?.domain_name} orderId={orderId} />
      )}
    </div>
  );
};

export default PayHostingFee;
